module.exports = __webpack_public_path__ + "img/GehenSieVonMirRunter.bcf50c29.svg";